export const getFormattedDate = () => {
  const currentDate = new Date();
  return `${currentDate.getDate().toString().padStart(2, "0")}/${(
    currentDate.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${currentDate.getFullYear()}`;
};

export const convertToNumberKWD = (value) => {
  if (typeof value === 'number') {
    return value; // Value is already a number, return it as is
  }
  if (typeof value === 'string') {
    // Remove "KWD" and trim any whitespace, then parse as a number
    const numericValue = parseFloat(value.replace("KWD", "").trim());
    return isNaN(numericValue) ? 0 : numericValue; // Return 0 if parsing results in NaN
  }
  return 0; // Return 0 for undefined, null, or other types
};

export const toNumber = (value) => (isNaN(value) ? 0 : parseFloat(value));

/**
 * Format various date formats to YYYY-MM-DD format for HTML date inputs
 * Handles: YYYY-MM-DD, DD-MM-YYYY, timestamps, Date objects
 * @param {string|Date} dateString - Date in various formats
 * @returns {string} Date in YYYY-MM-DD format or empty string if invalid
 */
export const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  
  try {
    // Check if the date is already in YYYY-MM-DD format
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }
    
    // Handle DD-MM-YYYY format from API
    if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
      const [day, month, year] = dateString.split('-');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    
    // Handle timestamp or other formats - try to parse as Date
    const parsedDate = new Date(dateString);
    if (!isNaN(parsedDate.getTime())) {
      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
      const day = String(parsedDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    
    // If all else fails, return empty string
    console.warn('Unable to format date:', dateString);
    return "";
  } catch (error) {
    console.error('Error formatting date:', error, 'Date string:', dateString);
    return "";
  }
};

